import { Slider, styled } from '@mui/material';

const ThresholdSlider = styled(Slider, {
  shouldForwardProp: (prop) => prop !== 'customColor',
})(({ theme, customColor }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  height: 14,
  padding: 0,
  '& .MuiSlider-rail': { opacity: 0 },
  '& .MuiSlider-track': { opacity: 0 },
  '& .MuiSlider-thumb': {
    height: 14,
    width: 14,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid',
    borderColor: customColor,
    '&:hover, &.Mui-focusVisible': {
      boxShadow: `0 0 0 8px ${customColor}29`,
    },
    '&.Mui-active': {
      boxShadow: `0 0 0 12px ${customColor}1f`,
    },
  },
  '& .MuiSlider-valueLabel': {
    backgroundColor: customColor,
    borderRadius: theme.shape.borderRadius,
    fontSize: '0.75rem',
    padding: '0 8px',
    lineHeight: 1.5,
    height: 22,
    minWidth: 22,
  },
}));

export default ThresholdSlider;